import React from 'react';
import DocumentCard from '../DocumentCard';
import WatercolorWash from '../WatercolorWash';
import { useReveal } from '../../hooks/useReveal';
import {
  DOCUMENT_CATEGORIES,
  documentsByCategory,
} from '../../data/documents';
import '../../styles/DocumentArchive.css';

const DocumentArchive: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`archive psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <WatercolorWash
        variant="c"
        color="#c25a3a"
        opacity={0.18}
        style={{ top: '20px', left: '-100px' }}
      />

      <div className="archive__intro">
        <div className="archive__chapter">Anexo · Transparência</div>
        <h1 className="archive__head">
          O caderno <em>por dentro.</em>
          <br />
          <span className="archive__hand">— em PDF, sem segredos.</span>
        </h1>
        <p className="archive__lede">
          Reunimos aqui os documentos institucionais da associação:
          estatutos, planos de atividades, relatórios de contas, atas das
          reuniões, protocolos com a Câmara. Tudo o que escrevemos para
          ficar registado — disponível para consulta.
        </p>
        <p className="archive__contact">
          Falta algum documento? Diz-nos por{' '}
          <a href="mailto:geral@patinhassemlar.org">geral@patinhassemlar.org</a>.
        </p>
      </div>

      {DOCUMENT_CATEGORIES.map((cat) => {
        const docs = documentsByCategory(cat.id);
        if (docs.length === 0) return null;
        return (
          <div className="archive__group" key={cat.id}>
            <div className="archive__group-head">
              <h2 className="archive__group-label">{cat.label}</h2>
              <p className="archive__group-note">{cat.note}</p>
            </div>
            <div className="archive__grid">
              {docs.map((doc) => (
                <DocumentCard
                  key={doc.id}
                  doc={doc}
                  tapeColor={cat.tapeColor}
                />
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default DocumentArchive;
